import type { CohortProgressView } from "../CohortStudentProgressSection";

export function teacherCohortProgressUrl(cohortId: string, view: CohortProgressView = "by-student"): string {
  const qs = new URLSearchParams({ cohort: cohortId });
  if (view === "by-assignment") qs.set("view", "by-assignment");
  return `/teacher/submissions?${qs.toString()}`;
}

export function parseCohortProgressView(raw: string | null): CohortProgressView {
  if (raw === "by-assignment" || raw === "by-lesson") return "by-assignment";
  if (raw === "by-student" || raw === "matrix") return "by-student";
  return "by-student";
}
